module.exports = __webpack_public_path__ + "img/10800.9648c353.jpg";